import React from 'react';
import PropTypes from 'prop-types';
import Button from '../button/Button.jsx';
import Spinner from '../spinner/Spinner.jsx';
import PublishTooltip from './PublishTooltip.jsx';
import s from './PublishInstructions.module.scss';

const renderSpinner = (publishPending, label, status) => (publishPending && status !== 'RUNNING' && status !== 'FAILED' ? <Spinner loading={publishPending} small /> : label);

const PublishButtonAndTooltip = ({ handlePublishClick, isVisible, publishPending, status, stopDate, hasAssetsWritePermission }) => (
    <div className={s.publishSubmit}>
        <Button onClick={handlePublishClick} label={renderSpinner(publishPending, 'Publish Changes', status)} className={s.publishButton} disabled={publishPending || !hasAssetsWritePermission} />
        <PublishTooltip isVisible={isVisible} status={status} stopDate={stopDate} />
    </div>
);

PublishButtonAndTooltip.propTypes = {
    handlePublishClick: PropTypes.func.isRequired,
    hasAssetsWritePermission: PropTypes.bool.isRequired,
    isVisible: PropTypes.bool.isRequired,
    publishPending: PropTypes.bool.isRequired,
    status: PropTypes.string.isRequired,
    stopDate: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]).isRequired,
};

export default PublishButtonAndTooltip;
